document.addEventListener('DOMContentLoaded', function () {
  const observed = document.querySelector('.wt-product__features');
  const target = document.querySelector('.main-product__buy-buttons--container');

  if (!observed || !target) return;

  // Créer un spacer vide juste avant target
  const spacer = document.createElement('div');
  spacer.style.height = '0px'; // on ajuste dynamiquement
  spacer.style.display = 'none'; // il est invisible par défaut
  target.parentNode.insertBefore(spacer, target);

  const observer = new IntersectionObserver(([entry]) => {
    // Condition : hors écran ET au-dessus du viewport
    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
      // Mesurer la hauteur réelle de target
      const height = target.offsetHeight + 'px';

      spacer.style.height = height;
      spacer.style.display = 'block';

      target.classList.add('is-sticky');
    } else {
      spacer.style.height = '0px';
      spacer.style.display = 'none';

      target.classList.remove('is-sticky');
    }
  }, {
    root: null,
    threshold: 0,
  });

  observer.observe(observed);
});


document.addEventListener("DOMContentLoaded", function () {
  const readMoreSection = document.getElementById("read-more");
  const buttonGap = document.querySelector("#read-more .hero__button--gap");

  if (!readMoreSection || !buttonGap) return;

  if (readMoreSection.offsetHeight < 300) {
    readMoreSection.classList.add('is-small');
  }

  // Déplacer le bouton comme enfant direct de #read-more
  readMoreSection.appendChild(buttonGap);

  // Récupère le <a> à l'intérieur du bouton
  const link = buttonGap.querySelector("a");
  if (!link) return;

  // Événement click sur le lien
  link.addEventListener("click", function (e) {
    e.preventDefault(); // empêche le comportement par défaut du lien
    readMoreSection.classList.toggle("extended"); // toggle la classe
  });
  
});

document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("RegisterForm-rgpd");
  const button = document.getElementById("create-account-btn");
  const message = document.getElementById("warning-rgpd");

  if (checkbox && button) {
    checkbox.addEventListener("change", function () {
      if (this.checked) {
        button.disabled = false;
        button.style.opacity = "1";
        button.style.pointerEvents = "auto";
        message.style.display = "none";
      } else {
        button.disabled = true;
        button.style.opacity = "0.8";
        button.style.pointerEvents = "none";
        message.style.display = "block";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 1024) {
    const crossSell = document.querySelector(".wt-cart__cross-sell");
    if (crossSell) {
      crossSell.classList.add("wt-cart__cross-sell--collapsed");
    }
  }
});




